
export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">Studio</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Helping brands tell their stories through thoughtful visuals and strategic design solutions.
            </p>
          </div>
          
          <div>
            <h4 className="text-sm font-medium text-gray-900 mb-4">Navigation</h4>
            <div className="space-y-2">
              <a href="/work" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">Work</a>
              <a href="/about" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">About</a>
              <a href="/contact" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">Contact</a>
            </div>
          </div>
          
          <div>
            <h4 className="text-sm font-medium text-gray-900 mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors">
                <i className="ri-behance-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">© 2024 Studio. All rights reserved.</p>
          <a href="https://readdy.ai/?origin=logo" className="text-sm text-gray-500 hover:text-gray-700 transition-colors mt-4 md:mt-0">
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}